<div class="navbar-top-search-container">
  <!-- Navigation filter -->
  <div class="navbar-top-search-filter">
    <div class="navbar-top-search-title">
      <div class="navbar-top-search-path-icon">
        <i class="fas fa-sitemap"></i>
        <span>/</span>
        <span>/</span>
        <i class="fas fa-map"></i>
      </div>
      {{ "quick-search" | translate }}
    </div>

    <div class="navbar-top-search-input-wrapper">
      <input
        #navigationFilter
        class="navbar-top-search-input"
        type="text"
        autocomplete="off"
        (keyup)="filterText = $event.target.value; dropdownFilter()"
        (keyup.enter)="updateNavigation()"
        [placeholder]="('entity' | translate) + '/' + ('agrupation' | translate)"
      />

      @if (filterText != null && filterText.length > 0) {
        <i class="fas fa-xmark pointer" (click)="resetSearchBoxText()"></i>
      }
    </div>
  </div>
  <!-- Navigation tree results -->
  @if (clientList?.length > 0 && filterText?.length > 0 && someClientIncludes) {
    <app-navbar-top-navigation-tree
      [responsive]="responsive"
      [clientList]="clientList"
      [filterText]="filterText"
      [update]="update"
      (updateNavigationFlag)="updateNavigation($event)"
    ></app-navbar-top-navigation-tree>
  }
</div>
